import { compose, filter, find, path, propEq, sortBy, toLower } from 'ramda';
import { createSelector } from 'reselect';

export const selectUsers = state => path(['api', 'api-user', 'data'], state) || [];

export const selectActiveSubcontractorIdFromCompany = (state, ownProps) => path(['relationships', 'active-subcontractor', 'data', 'id'], ownProps.company);

export const getActiveSubcontractorFromCompany = createSelector(
  [selectUsers, selectActiveSubcontractorIdFromCompany],
  (users, userId) => {
    if (!userId || !users) return undefined;

    return find(propEq('id', userId))(users);
  },
);

export const makeGetActiveSubcontractorFromCompany = () => createSelector(
  [selectUsers, selectActiveSubcontractorIdFromCompany],
  (users, userId) => {
    if (!userId || !users) return undefined;

    return find(propEq('id', userId))(users);
  },
);

export const selectCompanies = state => path(['api', 'company', 'data'], state) || [];

const sortCompanies = sortBy(compose(toLower, (company) => path(['attributes', 'name'], company)));

export const filterNullRecords = (list, attribute) => (
  filter(element => path(['attributes', attribute], element) === null)(list)
);

export const selectActiveCompanies = createSelector(
  [selectCompanies],
  (companies) => {
    const filteredDeletedCompanies = filterNullRecords(companies, 'deleted-at');
    const filteredCompanies = filter(company => path(['attributes', 'is-active'], company) !== false)(filteredDeletedCompanies);

    return sortCompanies(filteredCompanies);
  },
);

export const selectInactiveCompanies = createSelector(
  [selectCompanies],
  (companies) => {
    const filteredDeletedCompanies = filterNullRecords(companies, 'deleted-at');
    const filteredCompanies = filter(company => path(['attributes', 'is-active'], company) === false)(filteredDeletedCompanies);

    return sortCompanies(filteredCompanies);
  },
);
